import THEME_COLORS from '../colors.scss';

export const COLORS = {
  BLACK: THEME_COLORS.BLACK,
  BLACK_LIGHT: THEME_COLORS.BLACK_LIGHT,
  BLACK_BACKDROP: THEME_COLORS.BLACK_BACKDROP,
  WHITE: THEME_COLORS.WHITE,
  WHITE_SECONDARY: THEME_COLORS.WHITE_SECONDARY,
  WHITE_BORDER: THEME_COLORS.WHITE_BORDER,
  PRIMARY: THEME_COLORS.PRIMARY,
  PRIMARY_LIGHT: THEME_COLORS.PRIMARY_LIGHT,
  PRIMARY_BORDER: THEME_COLORS.PRIMARY_BORDER,
  PRIMARY_DARK: THEME_COLORS.PRIMARY_DARK,
  PRIMARY_ACTIVE: THEME_COLORS.PRIMARY_ACTIVE,
  PRIMARY_HOVER: THEME_COLORS.PRIMARY_HOVER,
  PRIMARY_HOVER_LIGHT: THEME_COLORS.PRIMARY_HOVER_LIGHT,
  PRIMARY_INFO: THEME_COLORS.PRIMARY_INFO,
  GRAY: THEME_COLORS.GRAY,
  GRAY_DARK: THEME_COLORS.GRAY_DARK,
  GRAY_LIGHT: THEME_COLORS.GRAY_LIGHT,
  GRAY_LIGHT_SECONDARY: THEME_COLORS.GRAY_LIGHT_SECONDARY,
  GRAY_BLUE: THEME_COLORS.GRAY_BLUE,
  GRAY_BORDER: THEME_COLORS.GRAY_BORDER,
  GRAY_BORDER_DARK: THEME_COLORS.GRAY_BORDER_DARK,
  GRAY_BORDER_LIGHT: THEME_COLORS.GRAY_BORDER_LIGHT,
  GRAY_DISABLED: THEME_COLORS.GRAY_DISABLED,
  GRAY_TEXT: THEME_COLORS.GRAY_TEXT,
  SHADOW_DARK: THEME_COLORS.SHADOW_DARK,
  SHADOW_MEDIUM: THEME_COLORS.SHADOW_MEDIUM,
  SHADOW_LIGHT: THEME_COLORS.SHADOW_LIGHT,
  RED_LIGHT: THEME_COLORS.RED_LIGHT,
  RED_DARK: THEME_COLORS.RED_DARK,
  ERROR_LIGHT: THEME_COLORS.ERROR_LIGHT,
  WARNING_LIGHT: THEME_COLORS.WARNING_LIGHT,
  GREEN: THEME_COLORS.GREEN,
  SUCCESS_LIGHT: THEME_COLORS.SUCCESS_LIGHT,
};

export const EMOJIS = {
  HANDSHAKE_LIGHT: '🤝🏻',
  BACKHAND_INDEX_POINTING_RIGHT_LIGHT: '👉🏻',
  INPUT_NUMBERS: '🔢',
  SPARKLE_STAR: '🌟',
  SPARKLES: '✨',
  INCOMING_MESSAGE: '📩',
  KEY: '🗝️',
  SPEECH_BALLOON: '💬',
  HIGH_VOLTAGE: '⚡',
  DIRECT_HIT: '🎯',
  GEAR: '⚙️',
  GLOBE: '🌐',
  LINK: '🔗',
  RECEIPT: '🧾',
  MONEY_BAG: '💰',
  FACE_WITH_STEAM_FROM_NOSE: '😤',
  ANGRY_FACE: '😡',
  FACE_WITH_SPIRAL_EYES: '😵‍💫',
  EXPLODING_HEAD: '🤯',
  SMILING_FACE_WITH_SUNGLASSES: '😎',
  SMILING_FACE_WITH_SMILING_EYES: '😊',
  STAR_STRUCK: '🤩',
  PARTYING_FACE: '🥳',
  CONFETTI_BALL: '🎊',
  STAR: '⭐',
  GIFT: '🎁'
};
